// extracted by mini-css-extract-plugin
export default {"about":"about____CbmQqM","advantages":"advantages____CbmQqM","row":"row____CbmQqM","advContent":"advContent____CbmQqM","advName":"advName____CbmQqM"};